module.exports = __webpack_public_path__ + "static/img/dkwpx2-2.d5d805f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwpx2-2.png
// module id = 665
// module chunks = 0